import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import axios from 'axios';
import { getAdminAuthHeader } from './services/auth';

axios.interceptors.request.use((config) => {
  if (
    typeof config.url === 'string' &&
    config.url.includes('/api/') &&
    !config.url.includes('/api/admin/auth/login')
  ) {
    config.headers = {
      ...getAdminAuthHeader(),
      ...config.headers,
    };
  }
  return config;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
